<template>
    <div class="headContainer">
        <div class="menuList">
            <div class="menuTop">
                <div class="menuBtn" @click="showMenu">
                    <img src="./../../assets/list.png"/>
                    <span>栏目</span>
                </div>
                <div class="AllTitle">
                    <img src="./../../assets/phonelogo.png">
                </div>
            </div>
            <div class="menuBottom"
                 :style="{ left: showList ? '0':'-55%'}">
                <div class="menu">
                    <div class="menuTitle" @click="goIndex">首页</div>
                </div>
                <div class="menu" v-for="item in menuList" :key="'t' + item.id">
                    <div class="menuTitle flexRow"
                         @click="openDrop(item.id)"
                         :key="'h' + item.id">
                        <div>
                            {{item.title}}&nbsp;
                        </div>
                        <div class="order">
                            +
                        </div>
                    </div>
                    <div class="menuChild" v-if="item.expand" :key="'f' + item.id">
                        <ul>
                            <li v-for="child in item.children" :key="child.id" @click="openAllList(child.title, child.id, child.dtype, child.newslink)">
                                {{child.title}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="menu">
                    <div class="menuTitle" @click="goFeedback">委员反馈</div>
                </div>
                <div class="menu">
                    <div class="menuTitle" @click="goMistake">网站纠错</div>
                </div>
            </div>
        </div>
        <!-- <img src="https://media.lotusdata.com/136627375059280222.jpg" alt="" style="width:100%;margin-top: 0.9rem"> -->
        <!-- <div class="container">
            <div class="search flexRow">
                <input type="text" v-model="key" placeholder="请输入疾病、姓名、专用术语等关键词"/>
                <button @click="goSearch">搜索</button>
            </div>
        </div> -->
         <div class="container" style="margin-top: 0.9rem">
            <div class="search flexRow">
                <input type="text" v-model="key" placeholder="请输入疾病、姓名、专用术语等关键词"/>
                <button @click="goSearch">搜索</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "phoneHead",
        props: {
            menuList: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                showList:false,
                drop: false,
                key: ''
            }
        },
        methods: {
            goSearch () {
                this.$router.push({
                    path:'/more/search',
                    query: { key: this.key }
                });
            },
            showMenu () {
                this.showList = !this.showList
            },
            openDrop (id) {

                this.$emit('doDrop', id)
            },
            goIndex () {
                this.$router.push({
                    path:'/home'
                });
                this.showList = false;
            },
            goFeedback () {
                this.showList = false;
                this.$router.push({
                    path: '/more/feedback'
                });
            },
            goMistake () {
                this.showList = false;
                this.$router.push({
                    path: '/more/mistake'
                });
            },
            openAllList (title, id, dtype, newslink) {
                if(dtype == '1' && newslink) {
                  if (newslink.indexOf('https://www.sxbjxh.org.cn')!=-1) {
                    window.location.href= newslink
                    console.log('22222222222', newslink)
                    return
                  }else {
                    window.open(newslink)
                    return
                  }
                }
                if(id == '8707426274508819'){//基金捐赠
                //  window.open("http://wx.sxcs.n.gongyibao.cn/#/funddetail?state=wxauth&code=093DGXGa1letlB0epPHa1YdfrT2DGXGh")
                    window.open("http://wx.sxcs.n.gongyibao.cn/#/funddetail?id=744f8520-a780-4fc0-a15c-e8dff4f3b4a9")
                    return
                }
                 if(id == '126317164331286401'){ //内部刊物
                    window.open("https://share.lotusdata.com/teamcontent/index?orgId=44822039860616108")
                    return
                }
                // 专家介绍
                if (id == '23'){
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'commit' }
                    });
                    this.showList = false;
                    return
                }

                // 会议视频
                if (id == '366733301051119603') {
                    this.$router.push({
                        path:'more/doc',
                        query: { type: 'video', video: '会议视频' }
                    });
                    this.showList = false;
                    return
                }
                // 讲座视频
                if (id == '31') {
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'video', video: '公益讲座'  }
                    });
                    this.showList = false;
                    return
                }
                if (id == '33') {
                    // location.href = 'https://share.lotusdata.com/teamcontent/index?orgId=44822039860616108'
                     location.href = 'http://wx.sxcs.n.gongyibao.cn/#/funddetail?id=744f8520-a780-4fc0-a15c-e8dff4f3b4a9'
                    return
                }
                this.$router.push({
                    path:'/news/alllist',
                    query: { id: id, title: title }
                });
                this.showList = false;
            },
            tabStatus ()　{
                var id = "776122427202428814"
                var title = "下载专区"
                this.$router.push({
                    path:'/news/detail',
                    query: { id: id }
                });
            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @baseBase: #eaf0eb;
    @base: #3e8f83;
    .headContainer{
        width:100%;
        height: auto;
    }
    .container{
        width:92%;
        height: auto;
        padding:10px 4%;
        margin-top: 0.9rem;
        box-sizing: content-box;
    }
    .headTop{
        width: 100%;
        height: auto;
        display: block;
        overflow: hidden;
        .logo{
            width:100%;
            height: auto;
            display: block;
            img{
                width: 100%;
                height: auto;
                vertical-align: top;
            }
        }
    }
    .search{
        height: 40px;
        width:84%;
        padding:0 8%;
        margin-top:10px;
        box-sizing: content-box;
        input{
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;
            height: 100%;
            padding: 5px;
            color: #000;
            font-size:12px;
            border: 1px solid #dddddd;
            box-sizing: border-box;
            border-bottom-left-radius: 3px;
            border-top-left-radius: 3px;
        }
        button{
            font-size:12px;
            color: #fff;
            width:55px;
            height: 40px;
            background-color: @base;
            border-bottom-right-radius: 3px;
            border-top-right-radius: 3px;
        }
    }
    .menuList{
        width: 100%;
        height: auto;
        background-color: @base;
        position: fixed;
        top:0;
        left:0;
        width:100%;
        z-index: 99;
        .menuTop{
            width: 92%;
            height: 0.9rem;
            line-height: 0.5rem;
            margin:0 auto;
            box-sizing: content-box;
            /*border-bottom: 0.01rem solid #fff;*/
            position: relative;
            .menuBtn{
                position: absolute;
                top: 0.1rem;
                width: 0.5rem;
                height: 0.7rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-color: transparent;
                img{
                    width: 0.36rem;
                    height: 0.36rem;
                    padding-top: 0.1rem;
                    /*padding-left: 0.08rem;*/
                    box-sizing: content-box;
                    vertical-align: top;
                }
                span {
                    font-size: 12px;
                    color: #fff;
                    line-height: 16px;
                }
            }
            .AllTitle{
                color:#fff;
                font-size:15px;
                width:100%;
                text-align: center;
                padding-top: 0.05rem;
                img {
                    width: 3.6rem;
                    height: 0.8rem;
                    vertical-align: middle;
                }
            }
        }
        .collapse {
            width: 100%;
            height: auto;
            transition:height 0.35s ease;
        }
        .menuBottom{
            width: 50%;
            height: 100%;
            position: fixed;
            background-color: #fff;
            transition: left 0.3s ease-in-out;
            top: 0.9rem;
            overflow-y: scroll;
            box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
            .menu{
                width:100%;
                height: auto;
                display:block;
                border-bottom:1px solid #e5e5e5;
            }
            .menuTitle{
                color:#000;
                width:92%;
                padding:0 4%;
                height: 0.65rem;
                line-height: 0.65rem;
                text-indent: 0.2rem;
                font-size: 12px;
                box-sizing: content-box;
                justify-content: space-between;
            }
            .menuChild{
                color:#000;
                font-size:10px;
                background-color: #f9f9f9;
                ul{
                    margin-bottom: 0;
                }
                li{
                    width:92%;
                    padding:0 4%;
                    height: 0.5rem;
                    line-height: 0.5rem;
                    text-indent: 0.3rem;
                    border-bottom: 1px solid #efefef;
                    box-sizing: content-box;
                }
            }
            /*.menu:active{
              .menuChild{
                display: block;
              }
            }*/
            .order{
                font-size: 15px;
                /*width: 0px;*/
                /*height: 0px;*/
                /*display: inline-block;*/
                /*border-width: 3px;*/
                /*border-style: solid;*/
                /*border-color: #000 transparent transparent;*/
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/phone/phoneHead.vue